import { render, staticRenderFns } from "./anti-phishing.vue?vue&type=template&id=62fe4370&"
import script from "./anti-phishing.vue?vue&type=script&lang=js&"
export * from "./anti-phishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports